export default "/_next/static/chunks/fonts/Ubuntu-Medium-latin-8eae06008b06a16f304e54df5013ea16.woff2";